/* ==========================================================================
   TIGHA — Startseite
   Countdown, Schienen, Waschungen, Einblenden beim Scrollen.
   Läuft eigenständig; berührt nichts außerhalb von .h5.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Einblenden beim Scrollen ─────────────────────────────────────────── */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.h5 .rv:not(.in)');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(items, function (el) {
      // Was beim Laden schon sichtbar ist, wird sofort gezeigt.
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight * 0.92) { el.classList.add('in'); return; }
      io.observe(el);
    });
  }

  /* ── Countdown ────────────────────────────────────────────────────────── */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdown(scope) {
    var boxes = (scope || document).querySelectorAll('[data-countdown]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.cdReady === '1') return;
      var target = Date.parse(box.getAttribute('data-date'));
      if (isNaN(target)) { box.style.display = 'none'; return; }

      var f = {
        d: box.querySelector('[data-cd="d"]'),
        h: box.querySelector('[data-cd="h"]'),
        m: box.querySelector('[data-cd="m"]'),
        s: box.querySelector('[data-cd="s"]')
      };
      if (!f.d || !f.h || !f.m || !f.s) return;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { box.style.display = 'none'; return; } /* 30.09.2026: nach Ablauf ausblenden statt 00:00:00:00 */
        var sec = Math.floor(diff / 1000);
        f.d.textContent = pad(Math.floor(sec / 86400));
        f.h.textContent = pad(Math.floor(sec % 86400 / 3600));
        f.m.textContent = pad(Math.floor(sec % 3600 / 60));
        f.s.textContent = pad(sec % 60);
      }

      tick();
      box.dataset.cdReady = '1';
      var timer = setInterval(tick, 1000);
      box.addEventListener('cd:stop', function () { clearInterval(timer); });
    });
  }

  /* ── Schienen ─────────────────────────────────────────────────────────── */
  function initSliders(scope) {
    var buttons = (scope || document).querySelectorAll('.h5 .arrow-btn[data-slide]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.slideReady === '1') return;
      btn.dataset.slideReady = '1';
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.getAttribute('data-slide'));
        if (!rail) return;
        var card = rail.querySelector('.pcard') || rail.querySelector('.card');
        var step = card ? card.getBoundingClientRect().width + 2 : rail.clientWidth * 0.8;
        var per = Math.max(1, Math.floor(rail.clientWidth / step) - 1);
        rail.scrollBy({ left: step * per * Number(btn.getAttribute('data-dir') || 1), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* Rechte Kante: solange noch Karten folgen, blendet die Schiene aus (CSS: [data-end]). */
  function initRailEdges(scope) {
    var rails = (scope || document).querySelectorAll('.h5 .slider');
    Array.prototype.forEach.call(rails, function (rail) {
      if (rail.dataset.edgeReady === '1') return;
      rail.dataset.edgeReady = '1';
      function check() {
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 6;
        if (atEnd) rail.setAttribute('data-end', ''); else rail.removeAttribute('data-end');
      }
      rail.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
      setTimeout(check, 800);
    });
  }

  /* ── Waschungen ───────────────────────────────────────────────────────── */
  function initWash(scope) {
    var groups = (scope || document).querySelectorAll('[data-wash]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.washReady === '1') return;
      group.dataset.washReady = '1';

      var buttons = group.querySelectorAll('.wash-list button');
      var images = group.querySelectorAll('.frame img');
      var text = group.querySelector('[data-wash-text]');
      var styles = group.querySelector('[data-wash-styles]');

      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-w');
          Array.prototype.forEach.call(buttons, function (b) { b.classList.toggle('on', b === btn); });
          Array.prototype.forEach.call(images, function (img) {
            img.classList.toggle('on', img.getAttribute('data-w') === key);
          });
          if (text) text.textContent = btn.getAttribute('data-text') || '';
          if (styles) styles.textContent = btn.getAttribute('data-styles') || '';
        });
      });
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initCountdown(scope);
    initSliders(scope);
    initRailEdges(scope);
    initWash(scope);
  }

  // Der Entwurf rendert Seiten dynamisch und ruft dies nach jedem Wechsel auf.
  window.tighaHome = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme-Editor: neu geladene Abschnitte bekommen ihre Funktionen zurück.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var box = e.target.querySelector('[data-countdown]');
    if (box) box.dispatchEvent(new CustomEvent('cd:stop'));
  });
})();
